// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Answer1_wrapper__2XyXx","appear":"Answer1_appear__1PM_3","title":"Answer1_title__3vIgr","button":"Answer1_button__3--OK","selected":"Answer1_selected__XPpYd"};